<template>
  <div class="row">
    <div class="col-xl-8 col-lg-12">
      <div class="card card-default">
        <service-wizard-layout
          title=""
          subtitle=""
          :parts="parts"
          :onComplete="onComplete"
          :validateStep="validateStep"
        >

        <template v-slot:nCentralCustomer>
          <form novalidate data-vv-scope="nCentralCustomer">
              <div class="row">
                <div class="col-xl-8 col-lg-12">
                  <div
                    class="form-group"
                    :class="{
                      'has-error': errors.has('nCentralCustomer.Customer'),
                    }"
                  >
                    <label class="control-label">nCentral Customer</label>
                    <div class="input-group">
                      <v-select
                        v-validate="'required'"
                        v-model="selectedCustomer.nCentralCustomerDescription"
                        name="Customer"
                        valueProp="nCentralCustomerDescription"
                        placeholder="Select nCentral Customer"
                        label="nCentralCustomerDescription"
                        :options="nCentralCustomers"
                        searchable
                      ></v-select>
                    </div>
                    <span
                      class="has-error"
                      v-if="errors.has('nCentralCustomer.Customer')"
                      >{{ errors.first("nCentralCustomer.Customer") }}</span
                    >
                  </div>
                </div>
              </div>
            </form>
        </template>
        </service-wizard-layout>
      </div>
    </div>
  </div>
</template>

<script>
import ServiceWizardLayout from "@/layouts/ServiceWizardLayout";
export default {
  components: {
    ServiceWizardLayout,
  },
  props: {
    emptySaleDefinition: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      parts: [
        {
          name: "nCentralCustomer",
          displayName: "NCentral Customer",
        }
      ],
      filledInSaleDefinition: {
        requiredObjs: {
          nCentralCustomer: {}
        }
      },
      nCentralCustomers: [],
      selectedCustomer: {},
    };
  },
  mounted: function () {
    this.filledInSaleDefinition = this.emptySaleDefinition;
    this.selectedCustomer = this.filledInSaleDefinition.requiredObjs.nCentralCustomer;
    
    this.$http.get(this.$config.aimsAPI + "managedservices/ncentral/customers/list")
      .then((response) => { 
          this.nCentralCustomers = response.body;
        },
        (error) => {
          this.showError("Error fetching NCentral Customers list", error);
          console.error(error);
        }
      );
  },
  methods: {
    validateStep: function (stepName) {
      return this.$validator.validateAll(stepName).then((result) => {
        if (result) {
          return true;
        } else {
          return false;
        }
      });
    },
    onComplete() {
      const customer = this.nCentralCustomers.find(c => c.nCentralCustomerDescription === this.selectedCustomer.nCentralCustomerDescription);

      this.filledInSaleDefinition.requiredObjs.nCentralCustomer.customerDescription = customer.nCentralCustomerDescription;
      this.filledInSaleDefinition.requiredObjs.nCentralCustomer.customerAccessCode = customer.nCentralCustomerAccessCode;

      this.$swal({
        title: this.filledInSaleDefinition.requiredObjs.nCentralCustomer.customerDescription,
        type: "warning",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonText: "Create Service",
      }).then((result) => {
        if (result.value) {
          this.$emit("createSale", this.filledInSaleDefinition);
        }
      });
    },
  },
};
</script>
